import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'

const Content = ({
	findElements,
	renderList,
	type,
	loadingOptions,
	hasAsyncSearch,
	search,
	changeType,
	handleAsyncSearch,
	handleChangeSearch,
	handleClickClear,
	handleClickCheckbox,
	handleClickRadio,
	handleClickFilter,
	onChange,
	selected,
}) => {
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState('')

	useEffect(() => {
		if (type === 'date') {
			if (
				Array.isArray(selected) &&
				selected.length === 2 &&
				selected[0] &&
				selected[1]
			) {
				const start = dayjs(selected[0]).isValid()
					? dayjs(selected[0]).format('YYYY-MM-DD')
					: ''
				const end = dayjs(selected[1]).isValid()
					? dayjs(selected[1]).format('YYYY-MM-DD')
					: ''
				setStartDate(start)
				setEndDate(end)
			} else {
				setStartDate('')
				setEndDate('')
			}
		}
	}, [selected, type])

	const handleApplyDate = () => {
		const start = startDate
			? dayjs(startDate).startOf('day').toISOString()
			: null
		const end = endDate ? dayjs(endDate).endOf('day').toISOString() : null

		if (onChange) {
			onChange([start, end])
		}
	}

	if (type === 'date') {
		return (
			<div className="filter-accordion__content" style={{ padding: '10px' }}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
						marginBottom: '15px',
					}}>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<label style={{ fontSize: '12px', fontWeight: 600, color: '#666' }}>
							De:
						</label>
						<input
							type="date"
							name="filterStartDate"
							id="filterStartDate"
							autoComplete="off"
							data-lpignore="true"
							data-form-type="other"
							className="filter-date-input"
							style={{
								padding: '6px',
								border: '1px solid #d9d9d9',
								borderRadius: '4px',
								width: '100%',
							}}
							value={startDate}
							onChange={(e) => setStartDate(e.target.value)}
						/>
					</div>

					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<label style={{ fontSize: '12px', fontWeight: 600, color: '#666' }}>
							Até:
						</label>
						<input
							type="date"
							name="filterEndDate"
							id="filterEndDate"
							autoComplete="off"
							data-lpignore="true"
							data-form-type="other"
							className="filter-date-input"
							style={{
								padding: '6px',
								border: '1px solid #d9d9d9',
								borderRadius: '4px',
								width: '100%',
							}}
							value={endDate}
							onChange={(e) => setEndDate(e.target.value)}
						/>
					</div>
				</div>

				<div
					className="filter-accordion__footer"
					style={{ display: 'flex', justifyContent: 'space-between' }}>
					<button
						type="button"
						className="btn-clear"
						onClick={() => {
							setStartDate('')
							setEndDate('')
							handleClickClear()
						}}>
						Limpar
					</button>

					<button
						type="button"
						className="btn-apply"
						onClick={handleApplyDate}
						disabled={!startDate && !endDate}>
						Aplicar
					</button>
				</div>
			</div>
		)
	}

	return (
		<div className="filter-accordion__content">
			{findElements && (
				<div className="filter-accordion__search-wrapper">
					<input
						type="text"
						className="filter-accordion__search-input"
						value={search}
						onChange={hasAsyncSearch ? handleAsyncSearch : handleChangeSearch}
						placeholder="Buscar..."
						autoComplete="off"
					/>
					{loadingOptions && <span className="loader">...</span>}
				</div>
			)}

			<ul className="filter-accordion__list">
				{loadingOptions && renderList.length === 0 ? (
					<li className="filter-accordion__empty">Carregando...</li>
				) : (
					renderList.map((item, index) => {
						if (item.visible === false) return null

						return (
							<li
								key={`${item.value}-${index}`}
								className={`filter-accordion__item ${item.active ? 'active' : ''}`}
								onClick={() =>
									type === 'checkbox'
										? handleClickCheckbox(item)
										: handleClickRadio(item)
								}>
								<div className={`filter-control ${type}`}>
									<span
										className={`control-indicator ${item.active ? 'checked' : ''}`}
									/>
									<span className="control-label">{item.label}</span>
								</div>
							</li>
						)
					})
				)}

				{!loadingOptions &&
					renderList.length > 0 &&
					renderList.every((i) => !i.visible) && (
						<li className="filter-accordion__empty">
							Nenhuma opção encontrada
						</li>
					)}
			</ul>

			<div className="filter-accordion__footer">
				<button type="button" className="btn-clear" onClick={handleClickClear}>
					Limpar
				</button>

				{changeType !== 'auto' && (
					<button
						type="button"
						className="btn-apply"
						onClick={handleClickFilter}>
						Aplicar
					</button>
				)}
			</div>
		</div>
	)
}

export default Content
